import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/scss/distributorVariables/variable.scss"
import "@/assets/scss/components/motor-dashboard-primevue-buttons.scss"
import "@/assets/scss/components/motor-dashboard-prime-dark.scss"
import store from './store/index';
import 'bootstrap'
import backendApi from './apis/axios-backend'
import "vue3-loading-skeleton/dist/style.css";
import VTooltip from 'v-tooltip';
import { formatIndianCurrency, sleep, isMobileView, openDatePicker, formatToINR } from './mixins/utils';
import { getAgentIdFromRmData } from './apis/utils';
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import Noir from './preset/Noir.js';
import DateField from '@/components/formComponents/DateField.vue';
import JourneyIdContainer from '@/components/common/JourneyIdContainer.vue';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
const myMixin = {
  data() {
    return {
        motorProductType: this.$store.state.motorProductType
    };
},
  methods: {
    backendApi,
    sleep,
    formatIndianCurrency,
    isMobileView,
    openDatePicker,
    formatToINR,
    getAgentIdFromRmData,
}
   
   
};
var app=createApp(App);
app.component('DateField', DateField);
app.component('JourneyIdContainer', JourneyIdContainer);

app.use(PrimeVue, {
    theme: {
        preset: Noir,
        options: {
            darkModeSelector: '.fake-dark-selector',
        }
    }
})

     app.use(store)
        .use(router)
        .mixin(myMixin)
        .use(VTooltip)
        .use(ToastService)
        .use(ConfirmationService);
  app.mount("#app");


